var exports = {
  "V": "xcc377c0b--0aa519--undergroundIcon",
  "G": "xcc377c0b--0aa519--undergroundIcon--icon",
};

module.exports = exports;
